import { message } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../../../../constants/service/common/utilConstants';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { csQnaActions } from '../../../../../store/modules/cs/qna';
import {
  CS_QNA_LIST_FILTER_OPTION_MODEL,
  CS_QNA_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/cs/qna/models';
import CsQnaList from '../CsQnaList';

const CsInQnaListWrap = () => {
  const { email } = useSelector((state) => state.app.adminInfo);
  const csQnaList = useSelector((state) => state.csQna.csQnaList);
  const dispatch = useDispatch();

  const getList = (data) => {
    const { filterOption, sortOption, pagination } = csQnaList;
    dispatch(
      csQnaActions.getCsQnaList({
        filterOption,
        sortOption,
        pagination,
        ...data,
      }),
    );
  };

  /**
   * 엑셀 다운로드
   */
  const getExcelDownload = () => {
    if (!csQnaList || !csQnaList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    dispatch(
      csQnaActions.getQnaExcelDownload({
        email,
        filterOption: csQnaList.filterOption,
        sortOption: csQnaList.sortOption,
      }),
    );
  };

  useEffect(() => {
    getList({
      filterOption: CS_QNA_LIST_FILTER_OPTION_MODEL,
      sortOption: CS_QNA_LIST_SORT_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });
  }, []);

  return (
    <div className="cs-inquiry-list-wrap">
      {/* 상품 문의 리스트 */}
      <CsQnaList csQnaList={csQnaList} getList={getList} getExcelDownload={getExcelDownload} />
    </div>
  );
};

export default CsInQnaListWrap;
